<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs headline="Danh sách giáo viên" :link="[{ text: 'Giáo viên', href: '../teachers' }]" />
      </div>
      <div class="flex-center">
        <v-btn
          v-if="$vuetify.breakpoint.mdAndUp && role.type !== 'inspector'"
          outlined
          @click="exportExcel"
          color="success"
        >
          <v-icon left>mdi-file-excel</v-icon> Xuất Excel
        </v-btn>
        <v-btn
          v-if="$auth.policies['add-new-teacher']"
          class="ml-6"
          depressed
          dark
          color="#0D47A1"
          @click.stop="createState = !createState"
        >
          <v-icon left>add</v-icon>{{ titleBtn }}
        </v-btn>
      </div>
    </div>

    <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
      <TeacherFilter @onFilterChanged="refresh" ref="teacherFilter"></TeacherFilter>
    </v-card>
    <v-card outlined class="mx-4 elevation-0"> <TeacherDataTable ref="teacherDataTable" /></v-card>

    <TeacherNewDialog :state="createState" @done="onFilter" />
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import TeacherFilter from '@/modules/teacher/TeacherFilter.vue'
import TeacherNewDialog from '@/modules/teacher/TeacherNewDialog'
import TeacherDataTable from '@/modules/teacher/TeacherDataTable'
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import utils from '@/plugins/utils'

export default {
  components: {
    Breadcrumbs,
    TeacherDataTable,
    TeacherFilter,
    TeacherNewDialog,
  },
  data() {
    return {
      isLoading: false,
      createState: false,
      allTeachers: [],
    }
  },
  computed: {
    ...mapState('teacher', ['teacher']),
    ...mapState('teachers', ['teacherSearchParams']),
    ...mapGetters('auth', ['profile', 'role']),

    titleBtn() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          return 'Thêm'
        default:
          return 'Thêm Giáo viên'
      }
    },
  },
  methods: {
    ...mapActions('teachers', ['fetchTeachers', 'searchTeachers']),
    ...mapActions('teaching', ['fetchTeachings']),
    async refresh(query) {
      await this.searchTeachers({ ...query })
    },
    onFilter() {
      this.$refs.teacherFilter.onFilterChanged()
    },
    async exportExcel() {
      this.$loading.active = true
      try {
        let excelHeader = this.$refs.teacherDataTable.headers.map(({ text, value }) => ({ text, value }))
        excelHeader = excelHeader.filter((excel) => excel.value !== 'action' && excel.value !== 'teachingClassCount')
        const filters = this.$options.filters
        const teacherTableFilters = this.$refs.teacherDataTable.$options.filters

        excelHeader.splice(1, 0, { text: 'Mã số', value: 'code' })

        const list = await this.fetchTeachers({ ...this.teacherSearchParams, _limit: -1 })
        const teachers = JSON.parse(JSON.stringify(list))
        const data = teachers.map((item) => {
          item.dob = filters.ddmmyyyy(item.dob)
          item.gender = filters.gender(item.gender)
          item.status = filters.teacherStatus(item.status)
          item.ownClasses = item.ownClasses ? item.ownClasses.length + '' : '0'
          item.leader = item.data && item.data.leaderSubjectGroup ? 'Có' : ''
          item.academicLevels = teacherTableFilters.getAcademicLevels(item)

          return item
        })
        utils.exportExcel(data, excelHeader, 'DanhSachGiaoVien')
      } catch (error) {
        this.$alert.error('Đã có lỗi xảy ra: ' + error)
      } finally {
        this.$loading.active = false
      }
    },
  },
}
</script>
